module.exports = __webpack_public_path__ + "static/media/prd-connect.22c66eeb.png";